import BaseLayout from 'components/layout/BaseLayout/BaseLayout';
import React from 'react';

const TestPage = () => {
  return <BaseLayout title="Virtual Venue Theme Editor">{/* <VirtualVenue virtualVenueData={data} /> */}</BaseLayout>;
};

export default TestPage;
